import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { SetInnerHTML } from '../../../../../../UI/SetInnerHTML/SetInnerHTML';

export function HOneHeader(props) {
  const [lastSearchTerm, setLastSearchTerm] = useState('');

  useEffect(() => {
    if (window?.location.href.indexOf('youSearchedFor=') != -1) {
      setLastSearchTerm(window.location.href.split('youSearchedFor=')[1].split('+').join(' '));
    } else {
      setLastSearchTerm('');
    }
  });

  if (props.passedAppFunctions.siteFormat == 'desktop') {
    return (
      <div className='HOneHeader col'>
        <div className='col-12 p-0'>
          {<SetInnerHTML innerHTML={props.widgetData.hOneText} /> ? (
            <h1 className={props.passedAppFunctions.navState.split('/')[1] == 'search-term' ? 'autocorrect-h1' : ''}>
              <SetInnerHTML innerHTML={props.widgetData.hOneText} />
            </h1>
          ) : (
            ''
          )}
          {lastSearchTerm !== '' && <h5>You searched for &quot;{lastSearchTerm}&quot;</h5>}
        </div>
      </div>
    );
  }

  return (
    <div className='HOneHeader col'>
      {<SetInnerHTML innerHTML={props.widgetData.hOneText} /> ? (
        <h1 className={props.passedAppFunctions.navState.split('/')[1] == 'search-term' ? 'autocorrect-h1' : ''}>
          <SetInnerHTML innerHTML={props.widgetData.hOneText} />
        </h1>
      ) : (
        ''
      )}

      {lastSearchTerm !== '' && <h5>You searched for &quot;{lastSearchTerm}&quot;</h5>}
    </div>
  );
}

export default HOneHeader;
